import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import Modal from "react-bootstrap/Modal";
import ReactPaginate from "react-paginate";

function ItCom() {
  const pagination = useRef();
  const peremailRef = useRef();
  const passRef = useRef();
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem('key'));
  let user_login_id = localStorage.getItem('userId')
  const [searchemail, setSearchemail] = useState('');
  const [emplist, setEmplist] = useState([]);
  const [totalitem, setTotalitem] = useState('');
  const [perPage, setPerpage] = useState('');
  const [email, setEmail] = useState();
  const [password, setPassword] = useState()
  const [timestopmodal, setTimestopmodal] = useState(false)
  const [userId, setUserId] = useState();
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [errMsgemail, setErrMsgemail] = useState('');
  const [errMsgpass, setErrMsgpass] = useState('');

  const [passtype, setPasstype] = useState('password');
  const handleShowPassword = () => {
    if (passtype == 'text') {
      setPasstype('password');
    } else {
      setPasstype('text')
    }

  }
  const handleUpdateEmail = (id) => {
    setUserId(id)
    setTimestopmodal(true)
  }
  const handleColose = () => {
    setTimestopmodal(false)
  }
  const handleUpdate = () => {
    setErrMsgemail('');
    setErrMsgpass('');
    let regEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
    let regpass = /^[a-zA-Z0-9]+([a-zA-Z0-9](_|-| )[a-zA-Z0-9])*[a-zA-Z0-9]+$/;
    if (!regEmail.test(email)) {
      setErr('red')
      setErrMsgemail(' This field is required')
      peremailRef.current.focus();
      return false;
    } else if (!regpass.test(password)) {
      setErr('red')
      setErrMsgpass(' This field is required')
      passRef.current.focus();
      return false;
    } else {
      const response = fetch(SERVER_URL + `api/it/update-official-email`,
        {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': `bearer ${token.value}`
          },
          body: JSON.stringify({
            EmpID: userId,
            email: email,
            password: password,
            requestedBY: user_login_id
          }),
        }).then(res => res.json())
        .then(data => {
          // console.log(data)
          if (data.status == true) {
            setMsg(data.msg)
            setErr('green')
            setTimeout(function () {
              setMsg('')
              setErr('')
              getNewjoineeList()
              setTimestopmodal(false)
            }, 1000);
          } else {
            setMsg('Error! something went wrong')
            setErr('red')
          }

        })
    }





  }
  const setPage = ({ selected }) => {
    getNewjoineeList(selected + 1);
  }
  useEffect(() => {
    getNewjoineeList()
  }, [])
  const getNewjoineeList = async (pagenumber) => {
    const response = await fetch(SERVER_URL + `api/it/it-request-list?query=${searchemail}&&page=${pagenumber == 'undefined' ? 1 : pagenumber}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
      })
      .then(res => res.json())
      .then(data => {
        setEmplist(data.result)
        setTotalitem(data.Emptotal[0].Total);
        setPerpage(data.limit)
      });
  }
  return (
    <>
      <Modal show={timestopmodal} id="">
        <div className="modal-body">
          <button type="button" onClick={handleColose} className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close">
            <i className="icon icon-cross"></i>
          </button>
          <div className="dash_white_box_ttl text-center" id="exampleModalLabel">Update Officially Email</div>
          <span style={{ color: err }}>{msg}</span>
          <form autoComplete="off">
            <div className="mb-3">
              <label className="col-form-label">Email<span style={{ color: err }}>{errMsgemail}</span></label>
              <input type="text" ref={peremailRef} onChange={(e) => { setEmail(e.target.value) }} value={email} className="form-control" placeholder="Enter Email" />
            </div>
            <div className="mb-3">
              <label className="col-form-label">Password<span style={{ color: err }}>{errMsgpass}</span></label>
              <div className='form-input'>
                <input type={passtype ? passtype : 'password'} ref={passRef} autoComplete="none" onChange={(e) => { setPassword(e.target.value) }} value={password} className="form-control" placeholder="Enter password" />
                <span className="icon_wrp">
                  <i className={`${passtype == "text" ? 'icon icon-eye-crossed' : 'icon icon-eye'}`} onClick={handleShowPassword} ></i>

                </span>
              </div>

            </div>
          </form>
          <div className="modalfooter">
            <button type="button" onClick={handleColose} className="btn_6 float-end ml10" data-bs-dismiss="modal">Cancel</button>
            <button type="button" onClick={handleUpdate} className="btn_5 float-end ">Add</button>
          </div>
        </div>
      </Modal>
      <div id="sidebar">
        <nav id="sidebarMenu" className="d-md-block sidebar">
          <div className="position-sticky">
            <ul className="nav flex-column">
              <li className="nav-item">
                <Link className="nav-link active" to="/updateemail">
                  Update Email
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link className="nav-link" to="/systeminformation">
                  System Information
                </Link>
              </li> */}
            </ul>
          </div>
        </nav>
      </div>
      <div id="content_area">
        <div className="page-header">
          <h1>Update Email</h1>
          <ul id="breadcrumbs" className="breadcrumb mb00">
            <li>
              <Link to='/dashboard'>Dashboard </Link>
            </li>
            <li className="current">
              <span>/</span> Update Email
            </li>
          </ul>
        </div>
        <div className="row_bg">
          <div className="row mb30">
            <div className="col-md-12">
              <table className="table_style_1">
                <thead>
                  <tr>
                    <th>Employee Code</th>
                    <th>Employee Name</th>
                    <th>Department </th>
                    <th>Designation	</th>
                    <th>EMPLOYEE TYPE</th>
                    <th>Contact</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {emplist?.map((item, ind) => {
                    return <tr key={ind}>
                      <td>{item.user_code ? item.user_code : ''}</td>
                      <td><span className="avatar_icon">{item.name ? item.name.match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase() : ''}</span>{item.name}</td>
                      <td>{item.dept_name}</td>
                      <td>{item.role_name}</td>
                      <td>Inhouse</td>
                      <td>{item.contact_no ? item.contact_no : ''}</td>
                      <td>
                        <button class="btn_7" onClick={(e) => { handleUpdateEmail(item.id) }}>Update</button>
                      </td>
                    </tr>
                  })}
                </tbody>
                <tfoot>
                  <tr><td colSpan="8" >
                    <span onClick={e => pagination.current.setState({ selected: 10 - 1 })} ></span>
                    <ReactPaginate
                      ref={pagination}
                      pageCount={Math.ceil(totalitem / perPage)}
                      pageRangeDisplayed={4}
                      marginPagesDisplayed={1}
                      onPageChange={setPage}
                      containerClassName="pagination"
                      activeClassName="active"
                      pageLinkClassName="page-link"
                      breakLinkClassName="page-link"
                      nextLinkClassName="page-link"
                      previousLinkClassName="page-link"
                      pageClassName="page-item"
                      breakClassName="page-item"
                      nextClassName="page-item"
                      previousClassName="page-item"
                      previousLabel={<>&laquo;</>}
                      nextLabel={<>&raquo;</>}
                    />
                  </td></tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ItCom
